import clsx from "clsx";
import React, { FC } from "react";

import { useHeaderMenu } from "../../../../hooks/use-header-menu";
import { HeaderMenuItem } from "../../common";

export interface HeaderMenuItemsProps {
  className?: string;
}

export const HeaderMenuItems: FC<HeaderMenuItemsProps> = ({ className }) => {
  const {
    headerMenu: { primaryItems, secondaryItems },
  } = useHeaderMenu();
  return (
    <div className={clsx("flex flex-col gap-6", className)}>
      {primaryItems?.map((item, i) => {
        if (!item) return null;
        return <HeaderMenuItem item={item} key={i} size="large" />;
      })}
      {!!primaryItems?.length && !!secondaryItems?.length && <hr />}
      {secondaryItems?.map((item, i) => {
        if (!item) return null;
        return <HeaderMenuItem item={item} key={i} size="small" />;
      })}
    </div>
  );
};
